import { XMarkIcon } from '@heroicons/react/24/outline';
import { usePacketBase } from '../Contexts/PacketBaseContext';
import { Mixpanel } from '../../../services/Mixpanel';
import { getPillNameFromSkillOrStandard } from '../../../utils/skills';
export const SelectedSkills = () => {
  const { languageStandards, contentStandard } = usePacketBase();

  if (languageStandards.length === 0 && !contentStandard) {
    return null;
  }

  return (
    <div className='flex gap-x-2 mb-2'>
      {languageStandards.map((skill) => (
        <SkillPill key={skill.id} skill={skill} type='language' />
      ))}
      {contentStandard && <SkillPill skill={contentStandard} type='content' />}
    </div>
  );
};

const SkillPill = ({ skill, type }) => {
  const { removeLanguageStandard, setContentStandard } = usePacketBase();
  const removeContentStandard = () => {
    setContentStandard(null);
  };
  return (
    <div className='text-xs border border-emerald-100 bg-emerald-50 text-gray-900 px-2 py-1 rounded-2xl flex items-center gap-x-1'>
      {getPillNameFromSkillOrStandard(skill)}
      <button
        onClick={() => {
          Mixpanel.track('Removed skill', { skill: skill.name, type });
          type === 'language' ? removeLanguageStandard(skill) : removeContentStandard();
        }}>
        <XMarkIcon className='w-4 h-4' />
      </button>
    </div>
  );
};
